import projectLogo from "assets/images/unify.png";
import projectLogoSidebar from "assets/images/unify_white.png";

const title = "Unify System";
export { projectLogo, title, projectLogoSidebar };
